<template>
  <div>
    <!-- 展示 -->
    <div class="content-padding">
      <el-input v-model="newBdProgress" :rows="2" :autosize="{ minRows: 2 }" type="textarea" placeholder="进展概述" @input="autoSaveRemarkLocal" />
      <div class="btn-box">
        <div v-if="company._id" class="radish-btn radish-btn-small" @click="openCompany(company._id)" style="margin-right:10px;">查看公司详情</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveBdProgress">保 存</div>
      </div>
      <div
        v-for="(item, index) in companyBdProgress"
        :key="index"
        :class="item && item.user === user ? 'remark-self' : ''"
      >
        <span class="remark-date">
          {{ dateFormat(item.createdAt) }} <span class="remark-time">{{ dateFormat(item.createdAt, 'HH:MM') }}</span> --
          {{ item.user }}
          <el-tag type="info" size="mini">{{ item.type || '客户详情' }}</el-tag>
        </span>
        <pre class="remark-info pd-10" style="text-indent:0">{{ item.content }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
  const dateFormat = require('dateformat')

  export default {
    props: {
      company: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        componentType: '公司介绍',
        companyBdProgress: [],
        newBdProgress: '',
        user: '',
      }
    },
    watch: {
      company: {
        async handler(value, oldValue) {
          if (value._id) {
            this.getCompanyRemark()
            this.getRemarkLocal()
          }
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.user = app.user.account
    },
    methods: {
      autoSaveRemarkLocal() {
        localStorage[`companyCommunication${this.componentType}${this.company._id}`] = this.newBdProgress
      },
      getRemarkLocal() {
        const remark = localStorage[`companyCommunication${this.componentType}${this.company._id}`]
        if (remark) this.newBdProgress = remark
      },
      clearRemarkLocal() {
        localStorage[`companyCommunication${this.componentType}${this.company._id}`] = ''
      },
      dateFormat(val, type) {
        return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
      },
      async getCompanyRemark() {
        const option = { cid: this.company._id }
        // const isManager = this.company.客户开发 === app.user.account
        // if (!isManager) option.type = '客户详情'
        const isManager = true

        const res = await app.service('company').newGetCompanyRemark(option)
        if (res.status === 'success') {
          const remarks = []

          if (isManager) {
            res.data.forEach((v) => {
              const arr = v.remark || []
              arr.forEach((a) => (a.type = v.type))
              remarks.push(...arr)
            })
          } else {
            const arr = (res.data && res.data.remark) || []
            arr.forEach((a) => (a.type = res.data.type))
            remarks.push(...arr)
          }

          remarks.sort((a, b) => b.createdAt - a.createdAt)
          this.companyBdProgress = remarks
        } else this.$message.error(res.msg)
      },
      async saveBdProgress() {
        const option = {
          cid: this.company._id,
          remark: { user: app.user.account, content: this.newBdProgress },
          type: '客户详情',
        }
        const res = await app.service('company').addCompanyRemark(option)
        if (res.status === 'success') {
          this.getCompanyRemark()
          this.newBdProgress = ''
          this.clearRemarkLocal()
        } else this.$message.error(res.msg)
      },
      openCompany(cid) {
        window.open(`${window.frontend}/#/company/${cid}`)
      },
    },
  }
</script>
<style src="../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style src="../../../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
.btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
}
</style>

